(() => {
  const BAR_SELECTOR = ".js-free-shipping-bar";

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
  const formatUSD = (cents) =>
    (cents / 100).toLocaleString(undefined, { style: "currency", currency: "USD" });

  async function fetchCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("Failed to fetch /cart.js");
    return res.json();
  }

  function updateBar(barEl, subtotalCents) {
    const thresholdCents = Number(barEl.dataset.thresholdCents || 0);
    if (!thresholdCents) return;

    const belowText = barEl.dataset.belowText || "away from FREE SHIPPING";
    const successText = barEl.dataset.successText || "You've unlocked FREE SHIPPING";

    const messageEl = barEl.querySelector(".js-free-ship-message");
    const fillEl = barEl.querySelector(".js-free-ship-fill");
    const trackEl = barEl.querySelector(".free-shipping-bar__track");

    const remaining = Math.max(0, thresholdCents - subtotalCents);
    const progress = clamp((subtotalCents / thresholdCents) * 100, 0, 100);

    if (messageEl) {
      messageEl.innerHTML =
        remaining > 0
          ? `<strong>${formatUSD(remaining)}</strong> ${belowText}`
          : successText;
    }
    if (fillEl) fillEl.style.width = `${progress}%`;
    if (trackEl) trackEl.setAttribute("aria-valuenow", String(Math.round(progress)));
  }

  let timer;
  async function refreshAll() {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      const bars = document.querySelectorAll(BAR_SELECTOR);
      if (!bars.length) return;

      try {
        const cart = await fetchCart();
        const subtotal = cart.items_subtotal_price ?? cart.total_price ?? 0;
        bars.forEach((bar) => updateBar(bar, subtotal));
      } catch (e) {
        console.warn("[free-shipping-bar] update failed", e);
      }
    }, 80);
  }

  document.addEventListener("DOMContentLoaded", refreshAll);

  // Catch Dawn AJAX/section re-renders (cart drawer updates)
  const obs = new MutationObserver(() => {
    if (document.querySelector(BAR_SELECTOR)) refreshAll();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // Also refresh after interactions inside cart UI
  document.addEventListener("click", (e) => {
    if (e.target.closest("cart-drawer") || e.target.closest("#CartDrawer") || e.target.closest("cart-items")) {
      refreshAll();
    }
  });
  document.addEventListener("change", (e) => {
    if (e.target.closest("cart-drawer") || e.target.closest("#CartDrawer") || e.target.closest("cart-items")) {
      refreshAll();
    }
  });
})();
